import {
	BrowserModule,
	HAMMER_GESTURE_CONFIG,
	HammerGestureConfig
} from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { HttpClientModule } from "@angular/common/http";

// import * as moment from 'moment';
// import 'moment/min/locales';
// import 'moment-timezone';

//import * as clipboard from "clipboard-polyfill/build/clipboard-polyfill.promise";
//const clipboard = require("clipboard-polyfill/build/clipboard-polyfill.promise");

import { registerLocaleData } from "@angular/common";
import localeTr from "@angular/common/locales/tr";

import { MatDateModule } from "@core/_shared/mat-date/mat-date.module";

import { AppComponent } from "./app.component";
import { AppRoutingModule } from "./app-routing.module";

import { AuthenticationModule } from "./core/auth/authentication.module";

import { LayoutModule } from "./content/layout/layout.module";
import { PartialsModule } from "./content/partials/partials.module";
import { CoreModule } from "./core/core.module";
import { LayoutConfigService } from "./core/services/layout-config.service";
import { PageConfigService } from "./core/services/page-config.service";
import { MenuConfigService } from "./core/services/menu-config.service";
import { UtilsService } from "./core/services/utils.service";
import { ClassInitService } from "./core/services/class-init.service";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { MatIconModule } from "@angular/material/icon";
import { MatPaginatorIntl } from "@angular/material/paginator";
import { OverlayModule } from "@angular/cdk/overlay";

import {
	PERFECT_SCROLLBAR_CONFIG,
	PerfectScrollbarConfigInterface,
} from "ngx-perfect-scrollbar";
import { LayoutConfigStorageService } from "./core/services/layout-config-storage.service";
import { LogsService } from "./core/services/logs.service";
import { QuickSearchService } from "./core/services/quick-search.service";
import { SubheaderService } from "./core/services/layout/subheader.service";
import { HeaderService } from "./core/services/layout/header.service";
import { MenuHorizontalService } from "./core/services/layout/menu-horizontal.service";
import { MenuAsideService } from "./core/services/layout/menu-aside.service";
import { LayoutRefService } from "./core/services/layout/layout-ref.service";
import { SplashScreenService } from "./core/services/splash-screen.service";
import { CookieService } from "ngx-cookie-service";

import { ClipboardService } from "./core/services/clipboard.sevice";

import "hammerjs";
import { ProgressSpinnerModule } from "./core/_shared/progress-spinner/progress-spinner.module";
import { MatPaginatorIntlTr } from "./config/customPaginator";
import { BurolarService } from "@core/services/http_services/genel/burolar.service";
import { VeriAlGonderService } from "@core/services/http_services/genel/verialgonder.service";

import { EtiketlerService } from "@core/services/http_services/genel/etiketler.service";
import { EbiletService } from "@core/services/http_services/ebilet/ebilet.service";
import { YolcuListesiService } from "@core/services/http_services/ebilet/yolculistesi.service";
import { BayiService } from "@core/services/http_services/genel/bayi.service";
import { KontorSiparisService } from "@core/services/http_services/genel/kontor-siparis.service";
import {
	API_BASE_URL,
	ConfigFactory,
	ConfigService,
	LOGIN_TIPI_ID,
} from "@core/services/config.service";
import { RecaptchaV3Module, ReCaptchaV3Service, RECAPTCHA_V3_SITE_KEY } from "ng-recaptcha";
import { environment } from "@environments/environment";
import { LoginTipleri } from "@core/genel/AppEnums";
import { HashingHelperService } from "@core/utils/hashing.helper.service";
import { DuyurularService } from '@core/services/http_services/genel/duyurular.service';
import {PlatformModule} from '@angular/cdk/platform';
import { VersiyonBilgileriService } from '@core/services/http_services/genel/versiyon-bilgileri.service';
import { CustomerService } from './core/services/customer.service';
import { FaturaService } from "@core/services/http_services/fatura/fatura.service";
import { FormsModule } from '@angular/forms'; 
import { ReactiveFormsModule } from '@angular/forms';
import { AlertModule } from "@core/modules/alert.module";

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
	// suppressScrollX: true
};

registerLocaleData(localeTr);

@NgModule({
	declarations: [AppComponent],
	imports: [
		AlertModule,
		BrowserAnimationsModule,
		BrowserModule,
		AppRoutingModule,
		HttpClientModule,
		LayoutModule,
		PartialsModule,
		CoreModule,
		OverlayModule,
		AuthenticationModule,
		NgbModule,
		TranslateModule.forRoot(),
		ProgressSpinnerModule,
		MatDateModule,
		RecaptchaV3Module,
		MatIconModule,
		PlatformModule,
		FormsModule,
		ReactiveFormsModule

	],
	providers: [
		LayoutConfigService,
		LayoutConfigStorageService,
		LayoutRefService,
		PageConfigService,
		MenuConfigService,
		UtilsService,
		ClassInitService,
		ClipboardService,
		LogsService,
		QuickSearchService,
		CookieService,
		SplashScreenService,
		ReCaptchaV3Service,
		{
			provide: RECAPTCHA_V3_SITE_KEY,
			useValue: environment.LOGIN_TIPI == LoginTipleri.makbuzTek ? "6LctRGscAAAAAJLPHgYgHz5O2R7C2KeGxTRtv6VV" : environment.LOGIN_TIPI == LoginTipleri.turkFatura ? "6LdZQ2scAAAAADBF-kAaJSMhF2snDqPKZwH8rSBm" : environment.LOGIN_TIPI == LoginTipleri.turkMakbuz ? "6LfKPmscAAAAAEIC_6uxF5rib-psS9vrxf8wrAPX":""
			//6LdpSv8ZAAAAAOZt-d21ojGqBzURGIVncGKPSCLU
		},
		{
			provide: PERFECT_SCROLLBAR_CONFIG,
			useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG,
		},
		{
			provide: MatPaginatorIntl,
			useClass: MatPaginatorIntlTr,
		},

		// template services
		SubheaderService,
		HeaderService,
		MenuHorizontalService,
		MenuAsideService,
		{
			provide: HAMMER_GESTURE_CONFIG,
			useClass: HammerGestureConfig,
		},
		BurolarService,
		VeriAlGonderService,
		EtiketlerService,
		EbiletService,
		YolcuListesiService,
		BayiService,
		KontorSiparisService,
		ConfigService,
		{ provide: 'CONFIG.JSON', useValue: '../assets/config.json' },
		{ provide: 'BASE-API-VARIABLE', useValue: 'API_URL' },
		{ provide: 'BASE-LOGIN-TYPE-VARIABLE', useValue: 'LOGIN_TIPI_ID' },
		{
			provide: API_BASE_URL,
			useFactory: ConfigFactory,
			deps: [ConfigService, "CONFIG.JSON", "BASE-API-VARIABLE"],
		},
		{
			provide: LOGIN_TIPI_ID,
			useFactory: ConfigFactory,
			deps: [ConfigService, "CONFIG.JSON", "BASE-LOGIN-TYPE-VARIABLE"],
		},
		HashingHelperService,
		DuyurularService,
		VersiyonBilgileriService,
		CustomerService,
		FaturaService

	],
	bootstrap: [AppComponent],
})
export class AppModule { }
